export enum MarketTimeConstantType {
  DATE,
  TODAY,
  TOMORROW,
}

export namespace MarketTimeConstantType {
  let elements = [
    MarketTimeConstantType.DATE,
    MarketTimeConstantType.TODAY,
    MarketTimeConstantType.TOMORROW,
  ];
  let alias = "com.bcdfx.model.MarketTimeConstantType";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
